/**
 * One headline share: of the records in the report, how many fall in the
 * "yes" groups. The groups underneath show the whole split, so the share is
 * checkable rather than a bare number.
 */
export function kpiShare(result, includeOptional) {
  const display = result?.display || {};
  const yes = new Set([
    ...(display.numerator || []),
    ...(includeOptional ? display.optional_numerator?.values || [] : []),
  ]);
  const total = result?.record_count || 0;
  const count = (result?.groups || [])
    .filter((group) => yes.has(String(group.label)))
    .reduce((sum, group) => sum + (group.count || 0), 0);
  const share = total ? Math.round((count / total) * 1000) / 10 : null;
  return { count, total, share, yes };
}

export default function KpiPercent({ result, includeOptional, onToggle, onGroupClick }) {
  const display = result?.display || {};
  const { count, total, share, yes } = kpiShare(result, includeOptional);
  const optional = display.optional_numerator;
  const noun = display.denominator_label || "records";

  if (!total) {
    return <p className="py-12 text-center text-sm text-[#4a5b68]">No records match this report.</p>;
  }

  return (
    <div>
      <div className="flex flex-wrap items-end gap-x-6 gap-y-2">
        <p className="font-sans text-5xl font-bold tabular-nums text-[#323c44]">
          {share === null ? "—" : `${share}%`}
        </p>
        <p className="pb-2 text-sm text-[#4a5b68]">
          {count} of {total} {noun}
        </p>
        {optional && onToggle && (
          <label className="mb-2 flex cursor-pointer items-center gap-2 text-sm text-[#4a5b68] print:hidden">
            <input
              type="checkbox"
              className="h-3.5 w-3.5 accent-[#50e3c2]"
              checked={Boolean(includeOptional)}
              onChange={(event) => onToggle(event.target.checked)}
            />
            {optional.label}
          </label>
        )}
      </div>
      <div className="mt-4 divide-y divide-[#efefef] rounded border border-[#efefef]">
        {(result.groups || []).map((group) => (
          <button
            key={group.key}
            type="button"
            className="flex w-full items-center justify-between px-3 py-2 text-left text-sm hover:bg-[#f5f5f5]"
            onClick={() => onGroupClick && onGroupClick(group.label)}
          >
            <span className={yes.has(String(group.label)) ? "font-semibold text-[#323c44]" : "text-[#4a5b68]"}>
              {group.label}
            </span>
            <span className="tabular-nums text-[#4a5b68]">
              {group.count}
              <span className="ml-2 text-[11px] text-[#7d8b96]">
                {Math.round((group.count / total) * 1000) / 10}%
              </span>
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
